// Comment as the GA4 is connected through nativ shopify google's channel
  // Google tag (gtag.js)
  // let gTagCDN = document.createElement('script');
  //     gTagCDN.src = 'https://www.googletagmanager.com/gtag/js?id=G-MXM3RBE659';
  //     gTagCDN.async = true;

  // // Append the script element to the document or the desired location
  // gTagCDN.addEventListener('load', () => {
  //   window.dataLayer = window.dataLayer || [];
  //   function gtag() {
  //     window.dataLayer.push(arguments);
  //   }
  //   gtag('js', new Date());
  //   gtag('config', 'G-MXM3RBE659');
  // });

  // // Append the script element to the document or the desired location
  // document.head.appendChild(gTagCDN);

(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"343049614", enableAutoSpaTracking: true};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");


(function(c,l,a,r,i,t,y){
  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "fuj0vy4b5j");